import { render, staticRenderFns } from "./module-info.vue?vue&type=template&id=0669ddc8&"
import script from "./module-info.vue?vue&type=script&lang=js&"
export * from "./module-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports